import { SVGProps } from 'react';

export const CircleExclamationMarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M6 5V6.875M10.5 6.5C10.5 8.98528 8.48528 11 6 11C3.51472 11 1.5 8.98528 1.5 6.5C1.5 4.01472 3.51472 2 6 2C8.48528 2 10.5 4.01472 10.5 6.5ZM6 8.375H6.00375V8.37875H6V8.375Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
